import axios from 'axios';
import { API_BASE_URL } from '@/app/config/api';
import { useAuthStore } from '@/app/store/authStore';

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true',
    },
});

// Add a request interceptor to include the auth token and organization ID
axiosInstance.interceptors.request.use(
    (config) => {
        // Get token and org ID from auth store or localStorage
        const authState = useAuthStore.getState();
        const token = authState.token || localStorage.getItem('authToken');
        const orgId = authState.userOrgId;

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        if (orgId) {
            config.headers['X-Organization-ID'] = orgId.toString();
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor for global error handling
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            // Handle based on status code
            if (error.response.status === 401) {
                // Unauthorized - Not logged in or invalid token
                useAuthStore.getState().logoutAction();
            }
            // Don't automatically redirect on 403 (Forbidden)
            // Let the component handle it with a proper error message
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
